import { Avatar } from "@mantine/core";
import "./TestimonialElement.css";

const TestimonialElement = (props) => {
  const { name, image, text, is_active, onClick } = props;

  return (
    <div onClick={onClick} className={`testimonialElement-father-div ${is_active ? "testimonialElement-father-div--active" : ""}`}>
     
      <div className="author">
        <div className="testimonialElement-avatar-container">
          <Avatar src={image} alt="Avatar testimonial section" radius="50%" size={60} />
        </div>
        <h5>
          {name}
        </h5>
       
      </div>
       <p className="testimonialElement-choped-text">{text}</p>
    </div>
  );
};
export default TestimonialElement;
